import {
  Cluster,
  ClusterStats,
  DefaultRenderer,
} from "@googlemaps/markerclusterer";

import { Z_INDEX_CLUSTER } from "../constants/constants";

// This custom cluster renderer is used to set the z-index of the cluster markers
// so that hovered and selected markers are always on top of the clusters
export class CustomClusterRenderer extends DefaultRenderer {
  render(
    cluster: Cluster,
    stats: ClusterStats,
    map: google.maps.Map
  ): google.maps.marker.AdvancedMarkerElement {
    const marker = super.render(cluster, stats, map);
    if (marker && "element" in marker) {
      const element = marker.element;
      if (element instanceof HTMLElement) {
        element.style.zIndex = String(Z_INDEX_CLUSTER);
      }
    }

    return marker as google.maps.marker.AdvancedMarkerElement;
  }
}
